import i18n from "src/i18n";


export const accountManagementInsightsEnabled =
  import.meta.env.VITE_ACCOUNT_MANAGEMENT_INSIGHTS_ENABLED !== "false";
export const recruiterAccountsEnabled =
  import.meta.env.VITE_RECRUITER_ACCOUNTS_ENABLED === "true";

export const getAccountManagementNavLinks = () => [
  { title: i18n.t("access.title"), link: "access" },
  { title: i18n.t("users"), link: "users" },
  ...(accountManagementInsightsEnabled
    ? [
        {
          title: i18n.t("recruitment"),
          link: "recruitment",
        },
      ]
    : []),
  ...(recruiterAccountsEnabled ? [{
    title: i18n.t("recruiters.title", "Recruiters"),
    link: "recruiters",
  }] : []),
  {
    title: i18n.t("verification-queue"),
    link: "verification-queue",
  },
  {
    title: i18n.t("profiles"),
    link: "profiles",
  },
  {
    title: i18n.t("partners"),
    link: "partners",
  },
  ...(accountManagementInsightsEnabled
    ? [
        {
          title: i18n.t("activation-engagement"),
          link: "activation-engagement",
        },
      ]
    : []),
  {
    title: i18n.t("files"),
    link: "files",
  },
  {
    title: i18n.t("promo-codes"),
    link: "promo-codes",
  },
];

export const firstAccessibleAccountPath = (canAccessPath: (path: string) => boolean) => {
  const tab = getAccountManagementNavLinks().find(item => canAccessPath(`account-management/${item.link}`));
  return tab ? `account-management/${tab.link}` : "account-management/access";
};
